export default "__VITE_ASSET__CsPS4_bg__"